export { EloStriketroughIcon } from './striketrough-icon'
